module.exports = __webpack_public_path__ + "img/letterhead-associate.f5900391.png";